/* Publish by EComposer at 2025-08-05 21:28:16*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2yl8mu1f3ii"]=  window.__ectimmers["ecom-2yl8mu1f3ii"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2yl8mu1f3ii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yl8mu1f3ii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cvekgyh8w7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cvekgyh8w7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qr4tmadsu9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qr4tmadsu9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbw4qhax33r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbw4qhax33r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l33lcslhxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l33lcslhxk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g9ucnvzrirj"]=  window.__ectimmers["ecom-g9ucnvzrirj"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-g9ucnvzrirj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9ucnvzrirj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yl9rv2tv3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yl9rv2tv3p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}